var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-leftsidebar overflow-auto"},[_c('div',{staticClass:"tab-content"},[_c('elProfile'),_c('elRooms'),_c('elMembers'),_c('elSetting')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }